<ng-container *transloco="let t">
  <p-confirmdialog />

  <!-- Use flex with column direction and set a fixed height -->
  <div class="flex flex-col">
    <!-- Content section - scrollable -->
    <div class="overflow-y-auto">
      <form [formGroup]="form">
        <formly-form [form]="form" [model]="model" [fields]="fields" [options]="options"></formly-form>
      </form>
    </div>

    <!-- Footer section - fixed -->
    <div class="mt-3 pt-3 border-t border-surface-200 dark:border-surface-700">
      <div class="flex flex-row justify-between flex-wrap gap-3 w-full">
        <!-- Left-aligned: Delete button -->
        <div>
          @if (approvalGroup) {
            <p-button
              [label]="t('app.common.delete')"
              icon="pi pi-trash"
              variant="outlined"
              severity="danger"
              (click)="openConfirmationDeleteDialog()"
              [disabled]="this.loading | async"
              [loading]="this.deleteLoading | async"
            />
          }
        </div>

        <!-- Right-aligned: Cancel and Save buttons -->
        <div class="flex gap-3 justify-end">
          <p-button
            [label]="t('app.common.cancel')"
            severity="secondary"
            (click)="ref.close()"
            [disabled]="this.loading | async"
          />
          <p-button
            [label]="t('app.common.save')"
            (click)="submitForm()"
            [disabled]="form.invalid || (this.loading | async)"
            [loading]="this.submitLoading | async"
          />
        </div>
      </div>
    </div>
  </div>
</ng-container>
